/* eslint max-len: 0 */
import React from 'react';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import Quote from './Quote.jsx';

export default class SectionQuote extends React.Component {
  render() {
    const sectionBg = require('images/quote-bg.jpg');

    return (
      <Section id={'quote'} sectionBg={sectionBg}>
        <Quote>{i18n.translate('quote.text')}</Quote>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionQuote.jsx
 **/